import { mockComponent } from 'bloko/common/setupMockComponents';

export { default as ButtonGroup } from 'bloko/blocks/button/ButtonGroup';

const { ButtonKind, ButtonIconPosition, ButtonScale, ButtonType, ButtonAppearance } =
    jest.requireActual('bloko/blocks/button/index.js');

export { ButtonKind, ButtonIconPosition, ButtonScale, ButtonType, ButtonAppearance };

export default mockComponent('Button', null, {
    withChildren: true,
});
